import { lifeCycleLiterals } from "../literals";

export const metamaskErrorsMap: {
  [key: string]: {
    eng: string;
  };
} = {
  INSUFFICIENT_FUNDS: {
    eng: "Insufficient funds for gas * price + value",
  },
  "-32000": {
    eng: lifeCycleLiterals.general.userRejectedTx,
  },
  "4001": {
    eng: lifeCycleLiterals.general.userRejectedTx,
  },
};
